import { PriceList } from '../../common/model/pricelist';
import { Observable, of } from 'rxjs';
import { AutoCompleteSelectionItem } from '../../core/component/autocomplete-remote/autocomplete-selection-item';
import { IAutoCompleteService } from '../../core/component/autocomplete-remote/autocomplete-service.interface';

export class PriceListItemPerPriceListAutocompleteService implements IAutoCompleteService {
  private _itemSelection: AutoCompleteSelectionItem[];

  private _priceLists: PriceList[] = [];
  set priceLists(priceLists: PriceList[]) {
    if (!priceLists) return;

    this._priceLists = priceLists;
  }

  get priceLists() {
    return this._priceLists;
  }

  private _priceListId: string;
  set priceListId(priceListId: string) {
    this._priceListId = priceListId;
    this._itemSelection = null;
  }

  get priceListId() {
    return this._priceListId;
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem> {
    if (!id) {
      return of(null);
    }
    if (!this._itemSelection) {
      if (this.priceLists) {
        let item = this.priceLists.flatMap(pl => pl.priceListItems).find(i => i.id === id);
        return of(new AutoCompleteSelectionItem(item.name, item.id, item.name));
      }
      return of(null);
    }
    return of(this._itemSelection.find(c => c.value === id));
  }

  getSelection(filter: string): Observable<AutoCompleteSelectionItem[]> {
    if (!this._itemSelection) {
      let listId = this.priceListId ?? (this.priceLists && this.priceLists.length ? this.priceLists[0].id : null);
      if (listId) {
        let priceList = this.priceLists.find(l => l.id === listId);
        this._itemSelection = priceList.priceListItems.map(item => new AutoCompleteSelectionItem(item.name, item.id, item.name));
      }
    }
    if (filter === '*') {
      return of(this._itemSelection);
    }

    // TODO: reused. what is this?
    let bestMatches = this._itemSelection.filter(c => c.name.toLowerCase().indexOf(filter.toLowerCase()) == 0);
    for (let match of this._itemSelection.filter(c => c.name.toLowerCase().indexOf(filter.toLowerCase()) > 0)) bestMatches.push(match);

    return of(bestMatches);
  }
}
